import { useEffect, useState } from 'react'
import useScreenSize from './use-screen-size'

export const useIsMobile = (): boolean => {
  const { width } = useScreenSize()
  const [isMobile, setIsMobile] = useState(width <= 785 && width !== 0)

  useEffect(() => setIsMobile(width <= 785 && width !== 0), [width])

  return isMobile
}

export default useIsMobile
